/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Tenantcolors1Inputs */

const en_entity_tenantcolors1 = /** @type {(inputs: Entity_Tenantcolors1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tenant Colors`)
};

const de_entity_tenantcolors1 = /** @type {(inputs: Entity_Tenantcolors1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mandantenfarben`)
};

/**
* | output |
* | --- |
* | "Tenant Colors" |
*
* @param {Entity_Tenantcolors1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_tenantcolors1 = /** @type {((inputs?: Entity_Tenantcolors1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Tenantcolors1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_tenantcolors1(inputs)
	return de_entity_tenantcolors1(inputs)
});
export { entity_tenantcolors1 as "entity_tenantColors" }